var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.671,
    height: 8.382,
    viewBox: "0 0 13.671 8.382",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Drop_Down",
    "data-name": "Drop Down",
    transform: "translate(0.705 0.705)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M2,5l6.131,7.177L14.261,5",
    transform: "translate(-2 -5)",
    fill: "none",
    stroke: "#14a4c2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropDown);
export default __webpack_public_path__ + "static/media/Drop Down.b6a72ca83a51f12d6b4ce40c1b3a24d7.svg";
export { ForwardRef as ReactComponent };